import React from "react";
import {useDisclosure} from "@chakra-ui/react";
import ChakraModalFromConfig, {FormConfig} from "../../common_components/ModalFormFromConfig";
import {api} from "../../api/timesheetAPI";
import {useAppDispatch, useAppSelector} from "../../stateManagement/hooks";
import {jiraBoardrefreshNofilters, setTimeTableLoading, timetableRefresh} from "../../stateManagement/refreshers";
import {showSwal} from "../../common_components/Alert";
import {HourCategories, LocationToDefaultCategory} from "./hourCategories";
import moment from "moment";
import {absenceBlockMessage, isAbsenceCodeBlocked} from "../TimeTable/WeekActions/absenceRestriction";

function AddWorklogUsingJira() {
    const {isOpen, onClose, onOpen} = useDisclosure();
    const user = useAppSelector(state => state.user.user)
    const impersonated = useAppSelector(state => state.impersonation.impersonatedUser)
    const defaultCategory= useAppSelector(state => state.user.preferences.defaultCategory)
    const dispatch = useAppDispatch()

    const handleSubmit = (formData: Record<string, string | boolean | number | [string, string]>) => {
        const jiraId = String(formData["jira_id"] ?? "");
        if (isAbsenceCodeBlocked(jiraId, user.name)) {
            showSwal("failed", absenceBlockMessage(user.name));
            return;
        }
        dispatch(setTimeTableLoading(true))
        api.addFromJirabutton({...formData, impersonate: impersonated}).then(value => {
            dispatch(timetableRefresh())
            dispatch(jiraBoardrefreshNofilters())
        }).catch(error =>
        showSwal("failed", error.response.data))
        dispatch(setTimeTableLoading(false))

    };

    const formConfig: FormConfig[] = [
        {label: "Story Jira ID", name: "jira_id", type: "text", required: true},
        {
            label: "Hours Category", name: "category", type: "dropdown", required: true,
            options: HourCategories
        },
        {label: "Log Period", name: "dates", type: "dateRange" , required: true},
        {label: "Time Spent per day", name: "time_logged", type: "number", postText: "(hours)" , required: true, autoFocus: true},
        {label: "Comment", name: "comment", type: "text"},
        {label: "Performance Incentive", name: "overtime", type: "boolean"}
    ];
    const initialValues = {
        jira_id: '',
        category:
            defaultCategory && defaultCategory !== ""
            ? defaultCategory
            : LocationToDefaultCategory[user.location],
        overtime: false,
        dates: [moment(new Date()).format("YYYY-MM-DD"), ""] as [string, string],

    }

    return (<>
            <button onClick={onOpen} className="aui-button">Book time with story Jira ID</button>
            <ChakraModalFromConfig isOpen={isOpen} onClose={onClose} onSubmit={handleSubmit} formConfig={formConfig}
                                   title={"Book time with story Jira ID"} initialValues={initialValues}/>
        </>
    );
};

export default AddWorklogUsingJira;

